export const VISITOR_MUTE_NOTIFY = 'VISITOR_MUTE_NOTIFY';
